<template>
    <Container>
        <div class="w-full flex my-4 gap-3">
            <Link href="/backstage/audiobooks/create"
                class="text-nomad-accent rounded-md py-2 px-3 bg-nomad-700 hover:bg-nomad-600">Create</Link>
            <Link href="/backstage" class="text-white rounded-md py-2 px-3 bg-nomad-900 hover:bg-nomad-800">Cancel
            </Link>
        </div>
        <div class="w-full my-4">
            <input type="text" placeholder="search audiobooks" class="rounded-md border-0 outline-0" />
        </div>
        <div class="w-full">
            <ul v-if="audiobooks && audiobooks.data" class="grid gap-3">
                <li v-for="audiobook in audiobooks.data" :key="audiobook.id"
                    class="p-3 bg-nomad-900 rounded-3xl text-white flex items-center">
                    <Link :href="'/backstage/audiobooks/' + audiobook.id + '/edit'" class="flex-1">
                    <h2 class="text-xl text-nomad-200">{{ audiobook.title }}</h2>
                    <div class="text-sm text-nomad-600">
                        <span>Author: {{ audiobook.author?.name }}</span>
                        <span class="mx-2">•</span>
                        <span>Narrator: {{ audiobook.narrator?.name }}</span>
                    </div>
                    <div v-if="audiobook.description" class="text-xs text-nomad-500 mt-1 line-clamp-2">
                        {{ audiobook.description }}
                    </div>
                    </Link>
                    <div class="flex items-center gap-4 text-nomad-400 text-sm">
                        <div class="flex items-center gap-1">
                            <span class="icon-headphones"></span>
                            <span>{{ audiobook.play_count || 0 }}</span>
                        </div>
                        <div class="flex items-center gap-1">
                            <span class="icon-star"></span>
                            <span>{{ audiobook.rating_count || 0 }}</span>
                        </div>
                        <span v-if="audiobook.is_premium" class="icon-award text-nomad-accent"></span>
                    </div>
                </li>
            </ul>
            <div v-else class="text-white text-center p-8">
                <p class="text-nomad-400">No audiobooks found</p>
            </div>
        </div>
    </Container>
</template>
<script setup>
import Container from "@/Pages/Backstage/Container.vue";
import { Link, usePage } from "@inertiajs/vue3";

const { audiobooks } = usePage().props
</script>